import { render, staticRenderFns } from "./StatusSelect.vue?vue&type=template&id=e2a458b4&scoped=true&"
import script from "./StatusSelect.vue?vue&type=script&lang=ts&"
export * from "./StatusSelect.vue?vue&type=script&lang=ts&"
import style0 from "./StatusSelect.vue?vue&type=style&index=0&id=e2a458b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2a458b4",
  null
  
)

export default component.exports